import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateSource } from "../../../../api/sourcesApi";
import { sourceSchema } from "../../schemas/sourceSchema";
const UpdateSourceDialog = ({
  openUpdateSource,
  handleCloseUpdateSource,
  currentSource,
  fetchSources,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(sourceSchema),
    defaultValues: {
      id: "",
      name: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.id = currentSource.id;
    defaultValues.serviceId = currentSource.serviceId;
    defaultValues.name = currentSource.name;
    defaultValues.email = currentSource.email;
    defaultValues.price = currentSource.price;
    reset({ ...defaultValues });
  }, [currentSource, reset]);

  const submitUpdateSource = async (values) => {
    await updateSource(values);
    handleCloseUpdateSource();
    fetchSources();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateSource}
        onClose={handleCloseUpdateSource}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Source</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateSource)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Source"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseUpdateSource}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateSourceDialog;
